import { Auth, AuthConfig } from '@foxcorp/foxkit-auth-js';

import { uiConfig } from '@/config/uiConfig';
import { configOptions } from '@/sdk/shared/profileOptions';

import { statefulRefreshToken } from './statefulRefreshToken';

let authSDK: Auth | null = null;

export function getAuthSDK(): Auth {
  if (authSDK) {
    return authSDK;
  }

  const config = new AuthConfig({
    ...configOptions,
    environment: uiConfig.environmentAlt,
    statefulRefreshToken,
    useEksEndPoints: true,
  });

  authSDK = new Auth(config);

  return authSDK;
}
